module.exports = __webpack_public_path__ + "img/createpodcast.62a165ed.png";